import http from '@/utils/http'
import convert from '@/utils/model-convert'
import { SearchArgument } from '@/models/client/receive-list'

const URL = '/rest/customer/feedback/resourceCount/cpcDayResourceCount'

export default {
  list ({search}, cb) {
    http.get(URL, {
      params: convert.toJson(search, SearchArgument)
    }).then(response => cb(response)).catch(trace => cb(trace.response))
  }
}



// WEBPACK FOOTER //
// ./src/api/client/cpc-receive-list.js